import {
  call, put, select, take,
} from 'redux-saga/effects';

import * as errorActions from '../../errors/actions';
import * as actions from './actions';
import * as services from './services';

export function* linkGuardianContactToAccount() {
  while (true) {
    try {
      yield take(actions.LINK_GUARDIAN_CONTACT_TO_ACCOUNT_REQUEST);

      const guardianContactNewsletter = yield select((state) => state.token.guardianContactNewsletter);

      const { id } = guardianContactNewsletter.data;

      yield call(services.updateGuardianContactNewsletter, { gcnid: id, lastOpenedAt: new Date().toISOString() });

      yield put(actions.linkGuardianContactToAccountSuccess({ guardianContactNewsletter }));
    } catch (error) {
      yield put(actions.linkGuardianContactToAccountFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}
